import { Component } from '@angular/core';

@Component({
  selector: 'app-status-page',
  templateUrl: './status-page.component.html',
  styleUrl: './status-page.component.scss'
})
export class StatusPageComponent {
  isSuccess: boolean = true; 
}
